import { Base } from "@studiometa/js-toolkit";
class Newsletter extends Base {
  mounted() {
    if (sessionStorage.getItem("newsletter_visible")) {
      return;
    }
    setTimeout(() => {
      this.$el.classList.add("is-visible");
      sessionStorage.setItem("newsletter_visible", "1");
    }, 15e3);
  }
  onCloseClick() {
    this.$el.classList.remove("is-visible");
  }
}
Newsletter.config = {
  name: "Newsletter",
  refs: ["close"]
};
export {
  Newsletter as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
